import { BaseBadgeProps } from "./types";

import "./styles.css";

const BaseBadge = ({
  leadingIcon,
  trailingIcon,
  children,
  borderColor,
  backgroundColor,
  fontColor,
  className,
  onClick,
  style,
}: BaseBadgeProps) => {
  return (
    <div
      className={`base-badge body-s-regular flex items-center justify-center gap-100 ${className} ${onClick ? "cursor-pointer" : ""}`}
      style={{
        border: `1px solid ${borderColor}`,
        backgroundColor: `${backgroundColor}`,
        color: fontColor,
        ...style,
      }}
      onClick={onClick}
    >
      {leadingIcon && <span>{leadingIcon}</span>}

      {children}

      {trailingIcon && <span>{trailingIcon}</span>}
    </div>
  );
};

export default BaseBadge;
